import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-step4-location',
  templateUrl: './step4-location.component.html',
  styleUrls: ['./step4-location.component.scss']
})
export class Step4LocationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
